import { NudgeAnimationOptions } from 'app/services/helpCenter';
import { Variants } from 'framer-motion';

export const bouncy: Variants = {
  initial: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },
  animate: (options: NudgeAnimationOptions) => ({
    translateX: 0,
    translateY: [0, -17, -13, -16, -15, 0],
    transition: {
      delay: 1,
      ease: 'easeInOut',
      times: [0, 0.25, 0.3, 0.4, 0.5, 1],
      duration: options.animation_duration / 1000,
      repeat: options.animation_repeats - 1,
      repeatDelay: options.repeat_delay / 1000,
    },
  }),
};
